function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15.157,
  height: 15.157,
  viewBox: "0 0 25.157 25.157"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.579 14.151A7.075 7.075 0 1 0 5.5 7.075a7.077 7.077 0 0 0 7.079 7.076m6.289 1.572h-2.707a8.55 8.55 0 0 1-7.164 0H6.289A6.29 6.29 0 0 0 0 22.013v.787a2.36 2.36 0 0 0 2.358 2.358H22.8a2.36 2.36 0 0 0 2.357-2.358v-.786a6.29 6.29 0 0 0-6.289-6.291",
  "data-name": "Icon awesome-user-alt",
  style: {
    fill: "#fff"
  }
}));
export { SvgUserWhite as ReactComponent };
export default __webpack_public_path__ + "images/user-white.ad13eb97.svg";